import { USER_REQUEST, USER_ERROR, USER_SUCCESS } from '../actions/user'
import api from '@/utils/apiClient'
import Vue from 'vue'
import { AUTH_LOGOUT } from '../actions/auth'

const state = { status: '', profile: {} }
// const userId = localStorage.getItem('user-id')

const getters = {
  getProfile: state => state.profile,
  isProfileLoaded: state => !!state.profile.name
}

const actions = {
  [USER_REQUEST]: ({commit}) => {
    // console.log('USER_REQUEST action')
    commit(USER_REQUEST)
    return api.get(`/users/${localStorage.getItem('user-id')}.json`)
      .then(response => response.data)
      .then(resp => {
        // console.log('USER_SUCCESS action')
        commit(USER_SUCCESS, resp)
      })
      .catch(() => {
        // console.log('USER_ERROR action')
        commit(USER_ERROR)
      })
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    // console.log('USER_REQUEST mutation')
    state.status = 'loading'
    state.loading_users = true
  },
  [USER_SUCCESS]: (state, resp) => {
    state.status = 'success'
    // state.loading_users = false
    localStorage.setItem('profile', JSON.stringify(resp))
    Vue.set(state, 'profile', resp)
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
    // state.loading_user = false
  },
  [AUTH_LOGOUT]: (state) => {
    state.profile = {}
    localStorage.removeItem('profile')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js